// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableBody_row__QuIgW {
  transition: all 0.3s ease-out;
  position: relative;
}
.TableBody_normalHeight__LWYK7 {
  height: 40px;
}
.TableBody_compactHeight__oOWVX {
  height: 32px;
}
.TableBody_largeHeight__cqISV {
  height: 48px;
}
.TableBody_tdData__dl3Qk {
  border-top: 1px solid #e1e1e1;
  text-align: start;
  padding: 0 8px;
  /* max-width: 300px; */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}
.TableBody_codeTd__G0GHN {
  width: 110px !important;
  max-width: 110px !important;
}
.TableBody_statusTd__rSWQ6 {
  width: 130px !important;
  max-width: 130px !important;
}
.TableBody_row__QuIgW:first-child > .TableBody_tdData__dl3Qk {
  border-top: 1px solid rgb(224, 224, 224);
}

.TableBody_tdCheckbox__6Wqlo {
  border-top: 1px solid #e1e1e1;
  text-align: start;
  padding: 0 12px;
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.TableBody_row__QuIgW:first-child > .TableBody_tdCheckbox__6Wqlo {
  border-top: 1px solid rgb(224, 224, 224);
}
.TableBody_row__QuIgW:last-child > .TableBody_tdCheckbox__6Wqlo {
  border-end-start-radius: 10px;
}
.TableBody_row__QuIgW:nth-child(odd) {
  background-color: #f8f8f8;
}
.TableBody_row__QuIgW:hover {
  background-color: #e3f3fa;
}
.TableBody_tdRecord__6ArX2 {
  border-top: 1px solid #e1e1e1;
  text-align: start;
  padding-inline-start: 12px;
  padding-inline-end: 8px;
  /* padding: 0 8px; */
  max-width: 50px;
  width: 50px;
}
.TableBody_row__QuIgW:first-child > .TableBody_tdRecord__6ArX2 {
  border-top: 1px solid rgb(224, 224, 224);
}

/* ====MORE BTN==== */
.TableBody_moreBtn__IgSeR {
  position: relative;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: rgb(224, 224, 224);
  transform: translateY(3px);
  padding: 0 15px;
}
.TableBody_moreIcon__MJNSO {
  border-radius: 50%;
  transition: all 0.5s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableBody_activeMoreIcon__JOlUr {
  color: rgb(73, 104, 243);
  transform: scale(1.2) rotate(180deg);
  box-shadow: 0 -3px 3px #6388df70;
  background-color: #fff;
}
.TableBody_deactiveMoreIcon__dvTxD {
  color: #000;
}
.TableBody_tdActions__mB17M {
  width: 110px;
  text-align: end;
  border-top: 1px solid #e1e1e1;
}
.TableBody_row__QuIgW:first-child > .TableBody_tdActions__mB17M {
  border-top: 1px solid rgb(224, 224, 224);
}
/* .row:last-child > .tdData {
  border-bottom: 1px solid rgb(224, 224, 224);
}*/
.TableBody_row__QuIgW:last-child > .TableBody_actionsContainer__Hbzgw {
  border-end-end-radius: 10px;
}
/* ====ACTIONS SPAN==== */
.TableBody_actionsRowSpan__SVDR- {
  overflow-y: auto;
  background-color: rgb(255, 255, 255, 0.8);
  border: 1px solid rgb(224, 224, 224);
  border-radius: 10px;
  position: absolute;
  margin-inline-start: -70px;
  transform: translateY(-10px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 20px 0 20px;
  z-index: 97;
}
.TableBody_row__QuIgW:nth-last-child(1) .TableBody_moreBtn__IgSeR .TableBody_actionsRowSpan__SVDR-,
.TableBody_row__QuIgW:nth-last-child(2) .TableBody_moreBtn__IgSeR .TableBody_actionsRowSpan__SVDR-,
.TableBody_row__QuIgW:nth-last-child(3) .TableBody_moreBtn__IgSeR .TableBody_actionsRowSpan__SVDR- {
  transform: translateY(-100px);
}
/* ====ACTIONS BTN==== */
.TableBody_actionBtn__PBnZK {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 0;
}
.TableBody_editIcon__l-4f6,
.TableBody_logicalDeleteIcon__\\+\\+NV8,
.TableBody_restoreIcon__fvUnT,
.TableBody_phisicalDeleteIcon__zlAOK {
  font-size: 25px !important;
  color: #212121;
}
.TableBody_editIcon__l-4f6:hover {
  color: #f2be54;
}
.TableBody_editableLinkTable__EAsEv {
  padding-top: 12px;
}
.TableBody_logicalDeleteIcon__\\+\\+NV8:hover {
  color: mediumvioletred;
}
.TableBody_restoreIcon__fvUnT:hover {
  color: #1bb3a6;
}
.TableBody_phisicalDeleteIcon__zlAOK:hover {
  color: red;
}
.TableBody_showTxtBtn__4bRsy {
  /* width: 140px; */
  margin: auto;
  border-radius: 50%;
}
.TableBody_showInfosBtn__tycT7 {
  column-gap: 10px;
  display: inline-flex;
  background-color: transparent;
  /* background-color: rgb(28, 57, 187); */
  outline: none;
  border-radius: 25px;
  border: none;
  color: #000;
  cursor: pointer;
  /* margin: auto; */

  /* width: 29px;
  height: 29px; */
}
.TableBody_normalEyeBtn__dR5gB {
  padding: 0 3px;
}
.TableBody_compactEyeBtn__a34SZ {
  padding: 0 2px;
}
.TableBody_largeEyeBtn__VMT5- {
  padding: 0 5px;
}
.TableBody_eyeIcon__MTyQB {
  width: 24px;
  height: 24px;
}
.TableBody_eyeIcon__MTyQB:hover {
  color: blue;
  fill: blue;
}
.TableBody_compactEyeIcon__1NjfB {
  width: 18px;
  height: 18px;
}
.TableBody_selectInput__83KtL {
  width: 16px;
  height: 16px;
  transform: translateY(3px);
}
.TableBody_selectedRow__S266N {
  background-color: rgba(28, 57, 187, 0.08) !important ;
}
/* actions */
.TableBody_actionsContainer__Hbzgw {
  /* text-align: end;
  vertical-align: bottom;
  width: 40px;                                                  !!!!! NEW LOOK ON A BAD DAY !!!!!
  column-gap: 12px;
  padding: 0 10px;
  height: 100%;
  position: relative; 
  padding-left: 10px;*/
  /* position: relative; */
  overflow: visible;
  border-top: 1px solid rgb(224, 224, 224);
}
/* .selectableActionsSpan {
  margin-inline-start: -106px;  
}                                                                         !!!!! NEW LOOK ON A BAD DAY !!!!!
.unSelectableActionsSpan {
  margin-inline-start: -106px;
} */
.TableBody_actionsSpan__wBx79 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e3f3fa;
  opacity: 0;
  height: 100%;
  transition:
    background-color 0.3s ease-out,
    opacity 0.1s ease-in;
}
.TableBody_rtlActionsSpan__nme\\+W {
  left: 10px;
}
.TableBody_ltrActionsSpan__-mKbk {
  right: 10px;
}
.TableBody_row__QuIgW:hover .TableBody_actionsSpan__wBx79 {
  background-color: transparent;
  opacity: 1;
  /* pointer-events: all; */
}
.TableBody_skeletonRow__l-0wV {
  /* width: 100% !important; */
  height: 48px !important;
  /* position: absolute !important; */
}
.TableBody_skeletonTr__Bojah {
  position: relative;
}
.TableBody_skeletonTr__Bojah:first-child td {
  border-top: 1px solid rgb(224, 224, 224);
}
.TableBody_newSkeletonTd__eRk7j {
  position: absolute;
  width: 100%;
  top: 0;
  right: 0px;
  background-color: #ffffff;
  border-top: 1px solid #e1e1e1;
}
.TableBody_row__QuIgW:first-child > .TableBody_newSkeletonTd__eRk7j {
  border-top: 1px solid rgb(224, 224, 224);
}
.TableBody_newSkeletonSpanContainer__PYtaR {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.TableBody_newSkeleton__\\+Eaoo {
  height: 48px !important;
  width: 100%;
}
.TableBody_emptyTr__yA2rS {
  height: 400px;
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; */
}
.TableBody_emptyTd__zTyc\\+ {
  text-align: center;
  border-top: 1px solid rgb(224, 224, 224);
}
.TableBody_noDataImg__z\\+mfT {
  /* width: 50%; */
  height: 50%;
  position: absolute;
}
.TableBody_ltrDir__9WSPD {
  direction: ltr;
}
.TableBody_downloadIconContainer__P267V {
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableBody_pointerCursor__DLti0 {
  cursor: pointer;
}
.TableBody_forcePe__nRJph {
  font-family: Estedad !important;
}
@media all and (max-width: 900px) {
  .TableBody_actionsSpan__wBx79 {
    background-color: transparent;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableBody/TableBody.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE;AACF;EACE,2BAA2B;AAC7B;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;AACb;AACA;;;EAGE,6BAA6B;AAC/B;AACA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;;;;EAIE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;;EAElB;iBACe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,qDAAqD;AACvD;AACA,YAAY;AACZ;EACE;;;;;;;sBAOoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;;;;;GAKG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ;;wBAEsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB;;;gBAGc;AAChB;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF","sourcesContent":[".row {\r\n  transition: all 0.3s ease-out;\r\n  position: relative;\r\n}\r\n.normalHeight {\r\n  height: 40px;\r\n}\r\n.compactHeight {\r\n  height: 32px;\r\n}\r\n.largeHeight {\r\n  height: 48px;\r\n}\r\n.tdData {\r\n  border-top: 1px solid #e1e1e1;\r\n  text-align: start;\r\n  padding: 0 8px;\r\n  /* max-width: 300px; */\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n.codeTd {\r\n  width: 110px !important;\r\n  max-width: 110px !important;\r\n}\r\n.statusTd {\r\n  width: 130px !important;\r\n  max-width: 130px !important;\r\n}\r\n.row:first-child > .tdData {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n\r\n.tdCheckbox {\r\n  border-top: 1px solid #e1e1e1;\r\n  text-align: start;\r\n  padding: 0 12px;\r\n  max-width: 220px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.row:first-child > .tdCheckbox {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n.row:last-child > .tdCheckbox {\r\n  border-end-start-radius: 10px;\r\n}\r\n.row:nth-child(odd) {\r\n  background-color: #f8f8f8;\r\n}\r\n.row:hover {\r\n  background-color: #e3f3fa;\r\n}\r\n.tdRecord {\r\n  border-top: 1px solid #e1e1e1;\r\n  text-align: start;\r\n  padding-inline-start: 12px;\r\n  padding-inline-end: 8px;\r\n  /* padding: 0 8px; */\r\n  max-width: 50px;\r\n  width: 50px;\r\n}\r\n.row:first-child > .tdRecord {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n\r\n/* ====MORE BTN==== */\r\n.moreBtn {\r\n  position: relative;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: rgb(224, 224, 224);\r\n  transform: translateY(3px);\r\n  padding: 0 15px;\r\n}\r\n.moreIcon {\r\n  border-radius: 50%;\r\n  transition: all 0.5s ease-out;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.activeMoreIcon {\r\n  color: rgb(73, 104, 243);\r\n  transform: scale(1.2) rotate(180deg);\r\n  box-shadow: 0 -3px 3px #6388df70;\r\n  background-color: #fff;\r\n}\r\n.deactiveMoreIcon {\r\n  color: #000;\r\n}\r\n.tdActions {\r\n  width: 110px;\r\n  text-align: end;\r\n  border-top: 1px solid #e1e1e1;\r\n}\r\n.row:first-child > .tdActions {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n/* .row:last-child > .tdData {\r\n  border-bottom: 1px solid rgb(224, 224, 224);\r\n}*/\r\n.row:last-child > .actionsContainer {\r\n  border-end-end-radius: 10px;\r\n}\r\n/* ====ACTIONS SPAN==== */\r\n.actionsRowSpan {\r\n  overflow-y: auto;\r\n  background-color: rgb(255, 255, 255, 0.8);\r\n  border: 1px solid rgb(224, 224, 224);\r\n  border-radius: 10px;\r\n  position: absolute;\r\n  margin-inline-start: -70px;\r\n  transform: translateY(-10px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 5px 20px 0 20px;\r\n  z-index: 97;\r\n}\r\n.row:nth-last-child(1) .moreBtn .actionsRowSpan,\r\n.row:nth-last-child(2) .moreBtn .actionsRowSpan,\r\n.row:nth-last-child(3) .moreBtn .actionsRowSpan {\r\n  transform: translateY(-100px);\r\n}\r\n/* ====ACTIONS BTN==== */\r\n.actionBtn {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 10px 0;\r\n}\r\n.editIcon,\r\n.logicalDeleteIcon,\r\n.restoreIcon,\r\n.phisicalDeleteIcon {\r\n  font-size: 25px !important;\r\n  color: #212121;\r\n}\r\n.editIcon:hover {\r\n  color: #f2be54;\r\n}\r\n.editableLinkTable {\r\n  padding-top: 12px;\r\n}\r\n.logicalDeleteIcon:hover {\r\n  color: mediumvioletred;\r\n}\r\n.restoreIcon:hover {\r\n  color: #1bb3a6;\r\n}\r\n.phisicalDeleteIcon:hover {\r\n  color: red;\r\n}\r\n.showTxtBtn {\r\n  /* width: 140px; */\r\n  margin: auto;\r\n  border-radius: 50%;\r\n}\r\n.showInfosBtn {\r\n  column-gap: 10px;\r\n  display: inline-flex;\r\n  background-color: transparent;\r\n  /* background-color: rgb(28, 57, 187); */\r\n  outline: none;\r\n  border-radius: 25px;\r\n  border: none;\r\n  color: #000;\r\n  cursor: pointer;\r\n  /* margin: auto; */\r\n\r\n  /* width: 29px;\r\n  height: 29px; */\r\n}\r\n.normalEyeBtn {\r\n  padding: 0 3px;\r\n}\r\n.compactEyeBtn {\r\n  padding: 0 2px;\r\n}\r\n.largeEyeBtn {\r\n  padding: 0 5px;\r\n}\r\n.eyeIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.eyeIcon:hover {\r\n  color: blue;\r\n  fill: blue;\r\n}\r\n.compactEyeIcon {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n.selectInput {\r\n  width: 16px;\r\n  height: 16px;\r\n  transform: translateY(3px);\r\n}\r\n.selectedRow {\r\n  background-color: rgba(28, 57, 187, 0.08) !important ;\r\n}\r\n/* actions */\r\n.actionsContainer {\r\n  /* text-align: end;\r\n  vertical-align: bottom;\r\n  width: 40px;                                                  !!!!! NEW LOOK ON A BAD DAY !!!!!\r\n  column-gap: 12px;\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  position: relative; \r\n  padding-left: 10px;*/\r\n  /* position: relative; */\r\n  overflow: visible;\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n/* .selectableActionsSpan {\r\n  margin-inline-start: -106px;  \r\n}                                                                         !!!!! NEW LOOK ON A BAD DAY !!!!!\r\n.unSelectableActionsSpan {\r\n  margin-inline-start: -106px;\r\n} */\r\n.actionsSpan {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #e3f3fa;\r\n  opacity: 0;\r\n  height: 100%;\r\n  transition:\r\n    background-color 0.3s ease-out,\r\n    opacity 0.1s ease-in;\r\n}\r\n.rtlActionsSpan {\r\n  left: 10px;\r\n}\r\n.ltrActionsSpan {\r\n  right: 10px;\r\n}\r\n.row:hover .actionsSpan {\r\n  background-color: transparent;\r\n  opacity: 1;\r\n  /* pointer-events: all; */\r\n}\r\n.skeletonRow {\r\n  /* width: 100% !important; */\r\n  height: 48px !important;\r\n  /* position: absolute !important; */\r\n}\r\n.skeletonTr {\r\n  position: relative;\r\n}\r\n.skeletonTr:first-child td {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n.newSkeletonTd {\r\n  position: absolute;\r\n  width: 100%;\r\n  top: 0;\r\n  right: 0px;\r\n  background-color: #ffffff;\r\n  border-top: 1px solid #e1e1e1;\r\n}\r\n.row:first-child > .newSkeletonTd {\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n.newSkeletonSpanContainer {\r\n  background-color: #ffffff;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n.newSkeleton {\r\n  height: 48px !important;\r\n  width: 100%;\r\n}\r\n.emptyTr {\r\n  height: 400px;\r\n  position: relative;\r\n  /* display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%; */\r\n}\r\n.emptyTd {\r\n  text-align: center;\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n}\r\n.noDataImg {\r\n  /* width: 50%; */\r\n  height: 50%;\r\n  position: absolute;\r\n}\r\n.ltrDir {\r\n  direction: ltr;\r\n}\r\n.downloadIconContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.pointerCursor {\r\n  cursor: pointer;\r\n}\r\n.forcePe {\r\n  font-family: Estedad !important;\r\n}\r\n@media all and (max-width: 900px) {\r\n  .actionsSpan {\r\n    background-color: transparent;\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `TableBody_row__QuIgW`,
	"normalHeight": `TableBody_normalHeight__LWYK7`,
	"compactHeight": `TableBody_compactHeight__oOWVX`,
	"largeHeight": `TableBody_largeHeight__cqISV`,
	"tdData": `TableBody_tdData__dl3Qk`,
	"codeTd": `TableBody_codeTd__G0GHN`,
	"statusTd": `TableBody_statusTd__rSWQ6`,
	"tdCheckbox": `TableBody_tdCheckbox__6Wqlo`,
	"tdRecord": `TableBody_tdRecord__6ArX2`,
	"moreBtn": `TableBody_moreBtn__IgSeR`,
	"moreIcon": `TableBody_moreIcon__MJNSO`,
	"activeMoreIcon": `TableBody_activeMoreIcon__JOlUr`,
	"deactiveMoreIcon": `TableBody_deactiveMoreIcon__dvTxD`,
	"tdActions": `TableBody_tdActions__mB17M`,
	"actionsContainer": `TableBody_actionsContainer__Hbzgw`,
	"actionsRowSpan": `TableBody_actionsRowSpan__SVDR-`,
	"actionBtn": `TableBody_actionBtn__PBnZK`,
	"editIcon": `TableBody_editIcon__l-4f6`,
	"logicalDeleteIcon": `TableBody_logicalDeleteIcon__++NV8`,
	"restoreIcon": `TableBody_restoreIcon__fvUnT`,
	"phisicalDeleteIcon": `TableBody_phisicalDeleteIcon__zlAOK`,
	"editableLinkTable": `TableBody_editableLinkTable__EAsEv`,
	"showTxtBtn": `TableBody_showTxtBtn__4bRsy`,
	"showInfosBtn": `TableBody_showInfosBtn__tycT7`,
	"normalEyeBtn": `TableBody_normalEyeBtn__dR5gB`,
	"compactEyeBtn": `TableBody_compactEyeBtn__a34SZ`,
	"largeEyeBtn": `TableBody_largeEyeBtn__VMT5-`,
	"eyeIcon": `TableBody_eyeIcon__MTyQB`,
	"compactEyeIcon": `TableBody_compactEyeIcon__1NjfB`,
	"selectInput": `TableBody_selectInput__83KtL`,
	"selectedRow": `TableBody_selectedRow__S266N`,
	"actionsSpan": `TableBody_actionsSpan__wBx79`,
	"rtlActionsSpan": `TableBody_rtlActionsSpan__nme+W`,
	"ltrActionsSpan": `TableBody_ltrActionsSpan__-mKbk`,
	"skeletonRow": `TableBody_skeletonRow__l-0wV`,
	"skeletonTr": `TableBody_skeletonTr__Bojah`,
	"newSkeletonTd": `TableBody_newSkeletonTd__eRk7j`,
	"newSkeletonSpanContainer": `TableBody_newSkeletonSpanContainer__PYtaR`,
	"newSkeleton": `TableBody_newSkeleton__+Eaoo`,
	"emptyTr": `TableBody_emptyTr__yA2rS`,
	"emptyTd": `TableBody_emptyTd__zTyc+`,
	"noDataImg": `TableBody_noDataImg__z+mfT`,
	"ltrDir": `TableBody_ltrDir__9WSPD`,
	"downloadIconContainer": `TableBody_downloadIconContainer__P267V`,
	"pointerCursor": `TableBody_pointerCursor__DLti0`,
	"forcePe": `TableBody_forcePe__nRJph`
};
export default ___CSS_LOADER_EXPORT___;
